<template>
	<b>
		{{config.datelify(expiry_date)}}<br>
		<span style="color: green"
			v-if="config.getExpire(expiry_date).total > 90">{{config.getExpire(expiry_date).value}}</span>
		<span style="color: blue"
			v-if="config.getExpire(expiry_date).total <= 90 && config.getExpire(expiry_date).total > 60">{{config.getExpire(expiry_date).value}}</span>
		<span style="color: orange"
			v-if="config.getExpire(expiry_date).total <= 60 && config.getExpire(expiry_date).total > 30">{{config.getExpire(expiry_date).value}}</span>
		<span style="color: red"
			v-if="config.getExpire(expiry_date).total <= 30 && config.getExpire(expiry_date).total > 0">{{config.getExpire(expiry_date).value}}</span>
		<span style="color: red"
			v-if="config.getExpire(expiry_date).total == 0 ">{{config.getExpire(expiry_date).value}}</span>
	</b>
</template>
<script>
	export default {
		props: ['expiry_date'],
		data() {
			return {

			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Expiry.vue